
function NoAccess() {
  window.location.replace(process.env.REACT_APP_NO_ACCESS_URL as string);
  return null;
}

export default NoAccess;
